import React, { useEffect, useState } from "react";
import MainLayout from "../layouts/MainLayout";
import { fetchPageData } from "../endpoint/pageApi";
import { useParams } from "react-router-dom";
import moment from "moment";
import { MarkdownComponent } from "../layouts/FormLayout";

const NewsPage = ({ isMobile }) => {
  const { slug } = useParams();
  const [loader, setLoader] = useState(false);
  const [newsData, setNewData] = useState({});

  useEffect(() => {
    fetchPageData(`news?filters[slug][$eq]=${slug}`, setNewData, setLoader);
  }, []);
  return (
    <>
      <MainLayout loader={loader}>
        <div
          className="container-fluid  p-0 overflow-x-hidden"
          style={{
            background: "#090D24",
          }}
        >
          <div className="row p-5 gap-5 ">
            <div className="col-12 text-center ">
              <div className="d-flex flex-column gap-2 text-center justify-content-center">
                <h1 className=" font-bold text-white news-heading">
                  {newsData?.title}
                </h1>

                <p className="mx-auto text-secondary news-description">
                  {newsData?.description}
                </p>
                <p className="w-100 text-white text-center fs14">
                  {newsData?.date
                    ? moment(newsData?.date, "YYYY-MM-DD").format(
                        "MMMM D, YYYY"
                      )
                    : "-"}
                </p>
              </div>
            </div>
          </div>

          <div className="row px-0 ps-md-5  pt-5 justify-content-center">
            <div
              className={`col-md-8 col-12 text-white ${
                isMobile ? "px-5 mb-5" : "pe-5"
              }`}
            >
              <MarkdownComponent
                markdown={newsData?.content}
                imgwidth={isMobile ? "" : "756px"}
                imgheight={isMobile ? "" : "427px"}
                markdowncss={isMobile ? "" : "text-center"}
              />
            </div>
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export default NewsPage;
